import React from 'react';
import { useSelector } from 'react-redux';
import '../forms.css';
import Copy from '../../copy';
import Help from '../../help';

const FormLabel = props => {
	const { showFormHelp } = useSelector(state => state.ui);

	const { label, labelFloat, help, infoHelp, id, mandatory, type, htmlFor } = props;

	return label ? (
		<>
			<label htmlFor={htmlFor}>
				<div className="flex flex-center">
					<div className="flex-grow">
						<span id={`label-${id || 'input'}`}>{label}</span>
						{mandatory && <span className="mandatory">*</span>}
						{infoHelp && <Help id={`help-text-${id || 'input'}`}>{infoHelp}</Help>}
					</div>
					{labelFloat && <span style={{ fontSize: '0.8em' }}>{labelFloat}</span>}
				</div>

				{(props.forceHelp || showFormHelp) && help && (
					<span className="form-control-help">
						<Copy value={help} />
					</span>
				)}
			</label>
		</>
	) : null;
};

export default FormLabel;
